/**
 * Court-sheet legend — HONEST. The backend `AvailabilitySlot` exposes only
 * `is_available`, not the block TYPE (Reserved / Drop-in / Clinic / League /
 * Maintenance). Rendering those sub-types would fabricate data the payload does
 * not carry, so this slice shows exactly two states. Each swatch carries a text
 * label (never color-only).
 *
 * The unavailable swatch reads "Not bookable" — consistent with the cell's
 * "Unavailable" state (both mean: you cannot book this hour) and WITHOUT
 * claiming the facility is "Closed" (the slot is unavailable at an open
 * facility — booked or held — and the payload does not say which).
 */
export function SheetLegend() {
  return (
    <Stack
      component="ul"
      direction="row"
      spacing={2}
      aria-label="What the cells mean"
      sx={{ listStyle: "none", p: 0, m: 0, flexWrap: "wrap" }}
    >
      {[
        { label: "Open · tap to add", color: "text.secondary" },
        { label: "Selected", color: "primary.main" },
        { label: "Unavailable · not bookable", color: "action.disabled" },
      ].map((item) => (
        <Stack
          component="li"
          key={item.label}
          direction="row"
          spacing={0.75}
          sx={{ alignItems: "center" }}
        >
          <Box
            aria-hidden="true"
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              bgcolor: item.color,
            }}
          />
          <Typography variant="caption" color="text.secondary">
            {item.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
